export const KiliOrganizationsQueryKeys = {
  all: ["kili", "queries", "organizations"] as const,
  detail: (orgId: number) => [...KiliOrganizationsQueryKeys.all, orgId] as const,
};

export const KiliOrganizationsMutationKeys = {
  all: ["kili", "mutations", "organizations"] as const,
};
